import styled from "styled-components";
import { Badge } from "react-bootstrap";

export const SWaitingSection = styled.div`
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SBadge = styled(Badge)`
  background: var(--primary-dark) !important;
  margin-right: 1rem;
  margin-bottom: 0.2rem;
  width: 100%;
`;
